import React, { useContext } from 'react';
import { GlobalContext } from '../context/GlobalState';
import {Transactions} from './Transactions';

function TransactionLists() {

    const { transactions } = useContext(GlobalContext);

    return (
        <>
            <h3>History</h3>
            <ul className="list">

                {
                    transactions.map((transaction) => {
                        return <Transactions key = {transaction.id} transaction={transaction} />
                    })
                }

            </ul>

        </>
    )
}

export default TransactionLists
